import React, {createContext, useReducer} from "react"
import {FeatureConfigReducer} from "../reducer/FeatureConfigReducer";

export const FeatureConfigContext = createContext()

const model = {
    feature: '',
    loading: true
}

const FeatureContextProvider = (props) => {
    const [ configViewModel, configDispatch ] = useReducer(FeatureConfigReducer, model)
    return (
        <FeatureConfigContext.Provider value = {{configViewModel, configDispatch}}>
            {props.children}
        </FeatureConfigContext.Provider>
    )
}

export default FeatureContextProvider


// WEBPACK FOOTER //
// ./src/commons/context/FeatureConfigContext.js